import { useStyles } from './styles';
import { Box, Button, Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

export const DocumentRequestPopup = (props) => {

  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog fullScreen={fullScreen} PaperProps={{ classes: { root: classes.dialogStyle }}} onClose={props.handleDocumentRequest} open={props.open}>
      <Box className={classes.root}>
    
        <Box className={classes.cardBody}>
          <Typography className={classes.statusTitle}>{(props.screen == 'support') ? 'Need a Document?' : 'CCPA Data Request Not Available for Your State'}</Typography>
        </Box>
        
        <Box className={classes.cardBodyContainer}>
          <Box className={classes.statusContainer}>
           <Box className={classes.cardContainer}>
             <Typography className={classes.paragraph}>{(props.screen == 'support') ? 
             'To request a specific document, please use the Document Request feature.This ensures your request is routed to the right team and processed quickly.' : 'It looks like your address is outside the state of California.' }</Typography> 
            {(props.screen == 'ccpa') && <Typography className={classes.paragraph}> Data privacy requests under CCPA (California Consumer Privacy Act) law can only be submitted by California residents at this point of time.</Typography>}
            {(props.screen == 'ccpa') && <Typography className={classes.paragraph}>If you have questions or need assistance, please <a href="./HelpLanding?contactus" target="_blank" className={classes.contact}>contact us</a> directly.</Typography>}
            </Box> 
          </Box>
        </Box>

        <Box className={classes.cardFooter}>
          <Button
            variant='contained'
            color='primary'
            className={classes.btn}
            onClick={props.handleDocumentRequest}
            >{(props.screen == 'support') ? 'Go to Document Request' : 'Got It'}</Button>
        </Box>
      </Box> 
    </Dialog>
  )
}
